/** Markdown was saved from Cricket Studio (flow viewer) and may diverge from the Review Studio session. */
export const DOCUMENT_STALE_REASON_FLOW_VIEWER = 'document_saved_in_flow_viewer';
/**
 * Stale from stitch or viewer step reorder/delete/frame — document must be regenerated before
 * trusting exports or continuing structured revision against the new flow shape.
 */
export function isStructuralDocumentStale(doc) {
    if (doc.isStale !== true) {
        return false;
    }
    return (doc.staleReason === 'flow_stitched' ||
        doc.staleReason === 'flow_events_reordered');
}
/**
 * `PUT /api/flows/:id/documents/:docId` is allowed unless the document is structurally stale.
 * Viewer-originated staleness still allows further raw markdown saves from Cricket Studio.
 */
export function documentAllowsFlowViewerMarkdownPut(doc) {
    if (doc.isStale !== true) {
        return true;
    }
    return doc.staleReason === DOCUMENT_STALE_REASON_FLOW_VIEWER;
}
/**
 * Removes Cricket-save staleness after Review Studio persists structured content to disk.
 */
export function dropFlowViewerStaleMetadata(doc) {
    if (doc.staleReason !== DOCUMENT_STALE_REASON_FLOW_VIEWER) {
        return doc;
    }
    const { isStale: _i, staleReason: _r, staleAt: _a, staleFromFlowId: _f, ...rest } = doc;
    return { ...rest };
}
